import Button from 'Components/Base/Button'
import Icon from 'Components/Base/Icon'
import React, { useState } from 'react'
import styled, { useTheme } from 'styled-components'

type Allergy = { medication: string; reaction: string[]; allergic: boolean }
interface Props {
  allergies: Allergy[]
  handleSetAllergies: (allergies: Allergy[]) => void
  handleSetOpenAllergies: () => void
}
const Allergies = ({ allergies, handleSetAllergies, handleSetOpenAllergies }: Props) => {
  const [search, setSearch] = useState('')
  const [symptoms, setSymptoms] = useState<string[]>([])
  const [openSymp, setOpenSymp] = useState<boolean>(false)
  const [openOtherAll, setOpenOtherAll] = useState<boolean>(false)
  const [allergyOther, setOtherAllergy] = useState<string>()
  const [openOtherSymp, setOpenOtherSymp] = useState<boolean>(false)
  const [sympOther, setOtherSymp] = useState<string>()
  const allergyOptions = ['Bactrim', 'Codeine', 'Lisinopril', 'Penicillin', 'Statins', 'Sulfa', 'Other']
  const symptomOptions = [
    'Anemia',
    'Asthma',
    'Hives',
    'Itching',
    'Nausea',
    'Rash',
    'Shock',
    'Swelling',
    'Tachycardia',
    'Throat Swelling',
    'Vomiting',
    'Other',
  ]

  const theme = useTheme()

  const selectAllergy = (item: string) => {
    setOpenSymp(!openSymp)
    if (item === 'Other') {
      setOpenOtherAll(true)
    }
    setSearch(item)
  }

  const addSymptom = (sym: string) => {
    if (sym === 'Other') {
      setOpenOtherSymp(!openOtherSymp)
    } else {
      setSymptoms(symptoms.includes(sym) ? symptoms.filter((s) => s !== sym) : [...symptoms, sym])
    }
  }

  const addAllergy = () => {
    handleSetAllergies([
      ...allergies,
      { medication: search === 'Other' ? allergyOther ?? '' : search, reaction: symptoms.concat(sympOther ?? ''), allergic: true },
    ])
    setOpenSymp(false)
    setOtherAllergy('')
    setOpenOtherSymp(false)
    setOtherSymp('')
    setOpenOtherAll(false)
    setSearch('')
    setSymptoms([])
  }

  return (
    <Container>
      <CloseButton onClick={() => handleSetOpenAllergies()}>✕</CloseButton>
      <SearchWrapper>
        <Icon name="search" color="#98A4AE" styles={{ margin: 5 }} />
        <SearchInput placeholder="Search for an allergy..." value={search} onChange={(e) => setSearch(e.target.value)} />
      </SearchWrapper>
      {/* <Icon name="search" color="#98A4AE" styles={{ margin: 5 }} />
      <SearchInput placeholder={`Search for an allergy...`} value={search} onChange={(e) => setSearch(e.target.value)} /> */}
      {!openSymp && (
        <Dropdown>
          {allergyOptions
            .filter((opt) => (search.length > 0 ? opt.toLowerCase().includes(search.toLowerCase()) : true))
            .map((opt) => (
              <DropdownItem key={opt} onClick={() => selectAllergy(opt)}>
                {opt} <p>Press to select.</p>
              </DropdownItem>
            ))}
        </Dropdown>
      )}
      {openOtherAll && (
        <SearchWrapper>
          <SearchInput placeholder="Enter an allergy" value={allergyOther} onChange={(e) => setOtherAllergy(e.target.value)} />
        </SearchWrapper>
      )}
      {openSymp && (
        <SymptomSection>
          <p>What symptoms do you usually experience?</p>
          <CheckboxList>
            {symptomOptions.map((sym) => (
              <label key={sym}>
                <Checkbox type="checkbox" checked={sym === 'Other' ? openOtherSymp : symptoms.includes(sym)} onChange={() => addSymptom(sym)} />
                {sym}
              </label>
            ))}
          </CheckboxList>
          {openOtherSymp && (
            <SearchWrapper>
              <SearchInput placeholder="Enter other symptoms" value={sympOther} onChange={(e) => setOtherSymp(e.target.value)} />
            </SearchWrapper>
          )}
          <Button styles={{ marginTop: 20 }} text="Add" leftIcon="circle-plus" backgroundColor={theme.colors.status.good} onClick={addAllergy} />
        </SymptomSection>
      )}
    </Container>
  )
}

export default Allergies
const Container = styled.div`
  width: 100%;
  padding: 16px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: #f9f9f9;
  margin-bottom: 20px;
  position: relative;
`

const SearchInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  font-size: 16px;
  background-color: #e6f6f8;
`

const Dropdown = styled.ul`
  list-style: none;
  margin: 8px 0px;
  padding: 0;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: white;
`

const DropdownItem = styled.li`
  display: flex;
  padding: 8px;
  height: 40px;
  cursor: pointer;
  p {
    display: none;
  }
  &:hover {
    background: #e6f6f8;
    p {
      display: flex;
      margin-left: auto;
      font-size: 14px;
    }
  }
`

const SymptomSection = styled.div`
  margin-top: 12px;
`

const CheckboxList = styled.div`
  margin-top: 8px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 6px;
`

const Checkbox = styled.input`
  width: 15px;
  height: 15px;
  margin-right: 8px;
  accent-color: #007b8f;

  /* Optional: make it even larger visually */
`

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 15px;
  cursor: pointer;
  color: #666;
  position: absolute;
  top: 0px;
  right: 0px;
`

const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  background-color: #e6f6f8;
  border: 1px solid #9bd3dd;
  border-radius: 4px;
  padding: 6px 8px;
  margin-top: 15px;
`
